import {
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomHandler<{ allPages: any;}>;

export const setPages: HandlerType = props => {
    props.dispatch({
        type: "Custom/PageLinks/SetPages",
        allPages: props.parameter.allPages
    });
};

export const chain = [setPages];

const setAllWebSitePages = createHandlerChainRunner(chain, "SetAllWebSitePages");
export default setAllWebSitePages;
